export default __webpack_public_path__ + "static/media/429.40910d1d.png";